import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import RequireWorkarea from "components/RequireWorkarea";
import RequireOrganization from "components/RequireOrganization";
import AnnotationModal from "./AnnotationModal";
import ChartModal from "./ChartModal";
import AnnotationSnackbar from "./AnnotationSnackbar";
import FilesListCard from "./FilesListCard";
import CastsInFileCard from "./CastsInFileCard";
import MapModal from "./MapModal";

const AnnotateLayout = props => (
  <RequireOrganization {...props}>
    <RequireWorkarea {...props}>
      <AnnotationModal {...props} />
      <ChartModal {...props} />
      <MapModal {...props} />
      <AnnotationSnackbar {...props} />

      <Row>
        <Col xs={12}>
          <FilesListCard {...props} />
        </Col>
      </Row>

      {props.filesBeingAnnotated.length > 0 && (
        <Row style={{ marginTop: "1rem" }}>
          <Col xs={12}>
            <CastsInFileCard {...props} />
          </Col>
        </Row>
      )}
    </RequireWorkarea>
  </RequireOrganization>
);

AnnotateLayout.propTypes = {
  filesBeingAnnotated: PropTypes.arrayOf(PropTypes.number)
};

AnnotateLayout.defaultProps = {
  filesBeingAnnotated: []
};

export default AnnotateLayout;
